import { render } from "./PendingDeliveries.vue?vue&type=template&id=46e78484"
import script from "./PendingDeliveries.vue?vue&type=script&lang=js"
export * from "./PendingDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__